import { gql } from "@apollo/client";

export const ASSETS = gql`
  query Assets($where: AssetWhereInput, $skip: Int, $take: Int) {
    assets(where: $where, skip: $skip, take: $take) {
      data {
        createdDate
        usdValue
        id
        type
        amount
        content {
          meta
          node
        }
        action {
          id
          type
          configuration
        }
        collateral {
          escrow {
            status
            transactions {
              module
              type
            }
          }
        }
      }
      count
    }
  }
`;

const asset = { ASSETS };

export default asset;
